import {
  Box,
  Center,
  CheckboxProps as ChakraCheckboxProps,
  forwardRef,
  omitThemingProps,
  useCheckbox,
  useCheckboxGroup,
  useMultiStyleConfig,
} from '@chakra-ui/react';
import { callAll } from '@chakra-ui/shared-utils';
import React from 'react';

import { Text } from '../../Text';

interface TextCheckboxProps extends ChakraCheckboxProps {}

const TextCheckbox = forwardRef<TextCheckboxProps, 'input'>((props, ref) => {
  const group = useCheckboxGroup();
  const ownProps = omitThemingProps(props);

  const {
    className,
    children,
    iconColor,
    iconSize,
    isChecked: isCheckedProp,
    isDisabled = group?.isDisabled,
    onChange: onChangeProp,
    ...rest
  } = ownProps;

  let isChecked = isCheckedProp;
  if (group?.value && ownProps.value) {
    isChecked = group.value.includes(ownProps.value);
  }

  let onChange = onChangeProp;
  if (group?.onChange && ownProps.value) {
    onChange = callAll(group.onChange, onChangeProp);
  }

  const {
    state,
    getInputProps,
    getCheckboxProps,
    getLabelProps,
    getRootProps,
  } = useCheckbox({
    ...rest,
    isDisabled,
    isChecked,
    onChange,
  });

  const Styles = useMultiStyleConfig('TextCheckbox', {
    checked: state.isChecked,
    disabled: state.isDisabled,
  });

  return (
    <Box as="label" sx={Styles.label} {...getRootProps()}>
      <input {...getInputProps({}, ref)} />
      <Center sx={Styles.box} {...getCheckboxProps()}>
        <Text as="b" {...getLabelProps()}>
          {children}
        </Text>
      </Center>
    </Box>
  );
});

export default TextCheckbox;
